/**
 * Instruction lines shown above a problem's expression. Templates may ONLY use
 * these keys. Params are substituted into {braces}; params that are MathMarkup
 * are rendered as math by the UI when the param name ends in "Math".
 *
 * Afrikaans follows CAPS wording ("Bepaal …", not the calque "Vind …"). Several
 * values in one Math param are joined with `\sep` ("a = 3 \sep b = 5"), never a
 * comma, which would read as a decimal comma in Afrikaans.
 */
export const INSTRUCTIONS = {
  fill: { en: 'Fill in the box', af: 'Vul die blokkie in' },
  solve: { en: 'Solve for {v}', af: 'Los op vir {v}' },
  evaluate: { en: 'Find the value if {assignMath}', af: 'Bereken die waarde as {assignMath}' },
  next: { en: 'What comes next?', af: 'Wat kom volgende?' },
  largerRoot: { en: 'Solve — give the larger root', af: 'Los op — gee die groter wortel' },
  smallerRoot: { en: 'Solve — give the smaller root', af: 'Los op — gee die kleiner wortel' },
  positiveRoot: { en: 'Solve — give the positive root', af: 'Los op — gee die positiewe wortel' },
  term: { en: 'Find term {n}', af: 'Bepaal term {n}' },
  sum: { en: 'Find the sum of the first {n} terms', af: 'Bepaal die som van die eerste {n} terme' },
  discriminant: { en: 'Find the discriminant Δ', af: 'Bepaal die diskriminant Δ' },
  findY: { en: 'Find {v}', af: 'Bepaal {v}' },
  simultaneous: { en: 'Solve together — find {v}', af: 'Los gelyktydig op — bepaal {v}' },
  boundary: { en: 'Solve the inequality', af: 'Los die ongelykheid op' },
  simplify: { en: 'Simplify', af: 'Vereenvoudig' },
  expand: { en: 'Expand', af: 'Brei uit' },
  factorise: { en: 'Factorise', af: 'Faktoriseer' },
  evaluateExpr: { en: 'Calculate', af: 'Bereken' },
} as const;

export type InstructionKey = keyof typeof INSTRUCTIONS;

export function instructionText(
  key: InstructionKey,
  params: Record<string, string | number> | undefined,
  locale: 'en' | 'af',
): string {
  let s: string = INSTRUCTIONS[key][locale];
  for (const [k, v] of Object.entries(params ?? {})) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}
